import { render, staticRenderFns } from "./AtomsSelect.vue?vue&type=template&id=2641166f&"
import script from "./AtomsSelect.vue?vue&type=script&lang=js&"
export * from "./AtomsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports